<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit ${configurationModule.branch}`
        : `Add ${configurationModule.branch}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
    :isHeader="isHeader"
  >
    <template #actions>
      <SecondaryButton
        id="branchManagementReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
        Reset
      </SecondaryButton>
      <PrimaryButton
        id="branchManagementSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="branchForm"
        :key="formCount"
        class="h-100"
        @submit.prevent="submitForm"
      >
        <v-row class="h-100 ma-0 pa-0">
          <v-col cols="12" lg="4" class="pa-0 pr-lg-2">
            <v-card elevation="0" class="h-100 pa-0 rounded-lg">
              <v-row class="ma-0 pa-4">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold"
                    >{{ configurationModule.branch }} Information</span
                  >
                </v-col>
                <v-col cols="12">
                  <InputField
                    id="name"
                    v-model="branchDetails.name"
                    name="name"
                    :label="`${configurationModule.branch} Name`"
                    :required="true"
                    :error-messages="formErrors.name"
                    @input="delete formErrors.name"
                  />
                </v-col>
                <v-col cols="12">
                  <InputField
                    id="code"
                    v-model="branchDetails.code"
                    :label="`${configurationModule.branch} Code`"
                    name="code"
                    :required="true"
                    :rules="[
                      (val) =>
                        (val && val.length >= 2 && val.length <= 10) ||
                        `${configurationModule.branch} Code should be between 2 to 10 Characters!`,
                    ]"
                    :error-messages="formErrors.code"
                    @input="delete formErrors.code"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Location Information</span
                  >
                </v-col>
                <v-col cols="12">
                  <SelectField
                    id="type"
                    v-model="branchDetails.country"
                    :itemsList="countryList"
                    name="type"
                    label="Country*"
                    itemText="name"
                    itemValue="id"
                    :isClearable="false"
                    :rules="[(val) => !!val || 'Country is required']"
                    :error-messages="formErrors.type"
                    @input="delete formErrors.type"
                    @change="onChangeCountry($event)"
                  />
                </v-col>
                <v-col cols="12">
                  <SelectField
                    v-model="branchDetails.currency"
                    :itemsList="currencyList"
                    name="currency"
                    itemText="code"
                    itemValue="id"
                    :label="`currency*`"
                    :rules="[(val) => !!val || 'currency is required']"
                    :isSearchRequired="false"
                    :error-messages="formErrors.currency"
                    @input="delete formErrors.currency"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    ref="addressField"
                    id="addressFieldID"
                    hide-details="auto"
                    label="Address*"
                    name="address"
                    dense
                    outlined
                    :class="
                      !branchDetails.country
                        ? 'unassigned lighten-3'
                        : 'background_color'
                    "
                    :disabled="!branchDetails.country ? true : false"
                    v-model="branchDetails.address"
                    :rules="[(val) => !!val || 'Address is required']"
                    :error-messages="formErrors.address"
                    @input="delete formErrors.address"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="8" class="pa-0 pl-2 pt-4 pt-lg-0 rounded-lg">
            <v-card elevation="0" class="rounded-lg">
              <GoogleMap
                mapId="branchMap"
                mapWidth="100%"
                mapHeight="calc(100vh - 160px)"
                ref="branchMap"
                :isDrawable="true"
                :showLocationName="true"
                :hasMapInfo="true"
              >
                <template #mapInfo>
                  <MapInfo legendType="branch" />
                </template>
              </GoogleMap>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { loadGoogleInstance, branchCodeValidation } from "@/utils/functions";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: {
    GoogleMap,
    BaseFormLayout,
    MapInfo,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    isHeader: {
      type: Boolean,
      default: true,
    },
    geoFenceValidationCheck: {
      type: Boolean,
      default: false,
    },
    refreshProfileDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      branchCodeValidation,
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      branchDetails: {},
      formErrors: {},
      countryList: [],
      currencyList: [],
      addressField: null,
    };
  },
  methods: {
    branchValidation(string) {
      let validRegex = /^[a-zA-Z][a-zA-Z0-9_-]+$/i;
      return validRegex.test(string);
    },
    getCurrencyList() {
      bus.$emit("showLoader", true);
      this.$api.currency
        .getCurrencyList({ limit: "all" })
        .then((res) => {
          this.currencyList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    resetForm() {
      this.$refs.branchForm.reset();
      let inter = setInterval(() => {
        if (this.$refs.branchMap && this.$refs.branchMap.map) {
          clearInterval(inter);
          this.$refs.branchMap.deleteShape();
          this.$refs.branchMap.removeAllMarkers();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(inter);
      }, 3000);
      if ("companyId" in this.$route.query) {
        this.branchDetails.company = this.$route.query.companyId;
      }
    },
    getCountryList() {
      this.$api.branch
        .getCountryList({ limit: "all" })
        .then((res) => {
          this.countryList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onChangeCountry(e) {
      this.setRestLocation();
      this.setAutoCompletedRestriction();
      let selectedCountry = this.countryList.find((country) => country.id == e);
      if (selectedCountry) {
        this.branchDetails.currency = selectedCountry.currency;
      }
    },
    setAutoCompletedRestriction() {
      let timer = setInterval(() => {
        if (this.addressField && window.google && window.google.maps) {
          clearInterval(timer);
          if (this.branchDetails.country && this.countryList) {
            let country = this.countryList.find(
              (v) => v.id == this.branchDetails.country
            );
            if (country && country.code) {
              this.addressField.setComponentRestrictions({
                country: [country.code],
              });
            }
          }
        }
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
      }, 3000);
    },
    setRestLocation() {
      this.branchDetails.address = null;
      delete this.branchDetails.address;
    },
    getBranchObject(id) {
      this.$api.branch
        .getBranchObject(id)
        .then((res) => {
          this.branchDetails = res.data;
          this.loadEditablePolygon();
          this.setAutoCompletedRestriction();
          let inter = setInterval(() => {
            if (this.$refs.branchMap) {
              clearInterval(inter);
              this.$refs.branchMap.addMultipleMarkers([
                { coordinates: this.branchDetails.coordinates, type: "Branch" },
              ]);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadEditablePolygon() {
      let path = [];
      this.branchDetails.serviceable_area.coordinates[0].forEach((element) => {
        path.push({ lat: element[1], lng: element[0] });
      });

      let inter = setInterval(() => {
        if (this.$refs.branchMap && this.$refs.branchMap.map) {
          clearInterval(inter);

          this.$refs.branchMap.setMapCenter({
            lat: this.branchDetails.coordinates.latitude,
            lng: this.branchDetails.coordinates.longitude,
          });
          this.$refs.branchMap.setMapZoom(9);

          this.$refs.branchMap.setEditablePolygon(
            path,
            this.branchDetails.serviceable_area.coordinates[0]
          );
        }
      });
    },
    submitForm() {
      if (!this.$refs.branchForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      let data = { ...this.branchDetails };

      let geoJSON = this.$refs.branchMap.convertToGeoJSON();
      if (this.geoFenceValidationCheck) {
        if (!geoJSON) {
          bus.$emit("showToastMessage", {
            message: "Please Draw your geofence before submitting the form!",
            color: "error",
            hasActions: true,
          });
          bus.$emit("showLoader", false);
          return;
        }
        data.serviceable_area = geoJSON.geometry;
      } else {
        data.serviceable_area = geoJSON ? geoJSON.geometry : null;
      }

      if (this.editMode) {
        this.$api.branch
          .updateBranchObject({
            id: this.branchDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Branch information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.push({ name: "branch-list" });
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      } else {
        this.$api.branch
          .createBranchObject(data)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Branch created!",
              color: "success",
            });
            this.resetForm();
            if (this.refreshProfileDetails) {
              bus.$emit("checkForBasicSetup");
            }
            if (!this.isHeader) {
              this.$emit("redirect", true);
            } else {
              this.$router.push({ name: "branch-list" });
            }
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },

    loadAutoComplete() {
      const interval = setInterval(async () => {
        if (this.$refs.addressField && window.google && window.google.maps) {
          clearInterval(interval);

          let addressElement = document.getElementById("addressFieldID");

          this.addressField = new window.google.maps.places.Autocomplete(
            addressElement
          );
          // this.addressField.setComponentRestrictions({
          //   country: [this.$globals.countryCode],
          // });

          addressElement.setAttribute("placeholder", "");

          this.addressField.addListener("place_changed", () => {
            let place = this.addressField.getPlace();

            this.branchDetails = {
              ...this.branchDetails,
              coordinates: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              },
              address: place.formatted_address,
            };
            this.$refs.branchMap.setMapCenter(place.geometry.location);
            this.$refs.branchMap.addMultipleMarkers([
              { coordinates: this.branchDetails.coordinates, type: "Branch" },
            ]);
            this.$refs.branchMap.setMapZoom(8);
          });
        } else {
          loadGoogleInstance();
        }
      }, 100);
    },
  },
  mounted() {
    this.loadAutoComplete();
    this.getCountryList();
    this.getCurrencyList();
    if ("companyId" in this.$route.query) {
      this.branchDetails.company = this.$route.query.companyId;
    }
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.getBranchObject(this.$route.params.id);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
